/* The book, its tiles and the Storymaker share one reversible scroll timeline. */
(function () {
  'use strict';
  var instances = new Map();
  var clamp = function (v) { return Math.max(0, Math.min(1, v)); };
  var phase = function (p, start, end) { var t = clamp((p - start) / (end - start)); return t * t * (3 - 2 * t); };
  var mix = function (a, b, t) { return a + (b - a) * t; };
  function init(root) {
    if (instances.has(root)) return;
    var stage = root.querySelector('[data-book-v3-stage]');
    var book = root.querySelector('[data-book-v3-object]');
    var cover = root.querySelector('[data-book-v3-cover]');
    var coverFront = root.querySelector('.rb3-cover-front');
    var coverBack = root.querySelector('.rb3-cover-back');
    var spread = root.querySelector('[data-book-v3-spread]');
    var device = root.querySelector('[data-book-v3-device]');
    var tiles = Array.from(root.querySelectorAll('[data-book-v3-tile]'));
    var leds = Array.from(root.querySelectorAll('[data-book-v3-led]'));
    var yellow = root.querySelector('.rb3-shape--yellow'), lavender = root.querySelector('.rb3-shape--lavender');
    var emptySlots = Array.from(root.querySelectorAll('[data-book-v3-empty]'));
    var labels = Array.from(root.querySelectorAll('[data-book-v3-label]'));
    var intro = root.querySelector('.rb3-intro');
    if (!stage || !book || !cover || !device) return;
    var desktop = window.matchMedia('(min-width: 900px)');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var frame = 0, viewportWidth = window.innerWidth;
    var snapTimer = 0, snapFrame = 0, snapArmed = false, snapMoved = false, touching = false, inputAt = 0;
    // Hold each pose across a stretch of scrolling, then travel to the next.
    // Mobile retains its existing left-page-first reading order.
    var holds = [[0, .025], [.225, .255], [.425, .455], [.625, .655], [.81, .83], [.98, 1]];
    var desktopPoses = [0, .265, .455, .715, .892, .97];
    var mobilePoses = [0, .32, .52, .75, .908, .97];
    var snapStops = [0, .24, .44, .64, .82, .99];
    function heldProgress(progress, mobile) {
      var poses = mobile ? mobilePoses : desktopPoses;
      for (var i = 0; i < holds.length; i++) {
        if (progress <= holds[i][1]) return poses[i];
        if (i + 1 < holds.length && progress < holds[i + 1][0]) {
          return mix(poses[i], poses[i + 1], (progress - holds[i][1]) / (holds[i + 1][0] - holds[i][1]));
        }
      }
      return poses[poses.length - 1];
    }
    function cancelSnap() {
      window.clearTimeout(snapTimer);
      window.cancelAnimationFrame(snapFrame);
      snapTimer = snapFrame = 0;
      snapArmed = false;
      snapMoved = false;
    }
    function settle() {
      snapTimer = 0;
      if (!snapArmed || touching || root.dataset.bookV3Mode !== 'scroll') return;
      snapArmed = false;
      var mobile = !desktop.matches;
      var introHeight = mobile && intro ? intro.offsetHeight : 0;
      var distance = root.offsetHeight - (mobile ? stage.getBoundingClientRect().height : window.innerHeight) - introHeight;
      var offset = -root.getBoundingClientRect().top - introHeight;
      // Never pull visitors back after they have left the pinned timeline.
      if (distance <= 0 || offset < 0 || offset > distance) return;
      var progress = offset / distance;
      // The picture is already settled inside a hold; don't undo scroll travel.
      if (holds.some(function (hold) { return progress >= hold[0] && progress <= hold[1]; })) return;
      var nearest = snapStops.reduce(function (best, point) { return Math.abs(point - progress) < Math.abs(best - progress) ? point : best; }, snapStops[0]);
      var from = window.scrollY, to = from + nearest * distance - offset;
      if (Math.abs(to - from) < 2) return;
      var started;
      function tick(time) {
        if (started === undefined) started = time;
        var t = clamp((time - started) / 360);
        window.scrollTo({ top: mix(from, to, t * t * (3 - 2 * t)), behavior: 'instant' });
        schedule();
        snapFrame = t < 1 ? window.requestAnimationFrame(tick) : 0;
      }
      snapFrame = window.requestAnimationFrame(tick);
    }
    function queueSnap() {
      window.clearTimeout(snapTimer);
      if (snapArmed && snapMoved && !snapFrame && !touching && Date.now() - inputAt < 2000 && root.dataset.bookV3Mode === 'scroll') {
        snapTimer = window.setTimeout(settle, 180);
      }
    }
    function scroll() { if (snapArmed) snapMoved = true; schedule(); queueSnap(); }
    function input(event) {
      cancelSnap();
      if (event.type === 'keydown' && (!['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', ' '].includes(event.key) || /^(INPUT|TEXTAREA|SELECT)$/.test(event.target.tagName) || event.target.isContentEditable)) return;
      if (event.ctrlKey || event.metaKey || event.altKey) return;
      if (event.type === 'wheel' && Math.abs(event.deltaX) >= Math.abs(event.deltaY)) return;
      if (event.type === 'touchstart') touching = true;
      if (event.touches && event.touches.length > 1) return;
      inputAt = Date.now();
      snapArmed = true;
    }
    function touchEnd() { touching = false; queueSnap(); }
    var animated = [book, cover, device].concat(tiles, labels, emptySlots, leds);
    if (intro) animated.push(intro);
    if (spread) animated.push(spread);
    if(yellow) animated.push(yellow); if(lavender) animated.push(lavender);
    function setReady(ready) {
      if (root.dataset.bookV3Ready === String(ready)) return;
      root.dataset.bookV3Ready = String(ready);
      root.dispatchEvent(new CustomEvent('raptor:book-ready', { bubbles: true, detail: { ready: ready } }));
    }
    function clear() {
      setReady(false);
      stage.style.removeProperty('--book-controls-top');
      root.style.removeProperty('--book-intro-height');
      root.style.removeProperty('--book-scroll-height');
      animated.forEach(function (node) { node.style.removeProperty('transform'); node.style.removeProperty('opacity'); node.style.removeProperty('--cover-alpha'); node.style.removeProperty('clip-path'); });
      ['width', 'left', 'top'].forEach(function (property) { device.style.removeProperty(property); });
      [coverFront, coverBack].forEach(function (face) { if (face) face.style.removeProperty('visibility'); });
    }
    function render() {
      frame = 0;
      if (root.dataset.bookV3Mode !== 'scroll') return;
      if (!desktop.matches && intro) root.style.setProperty('--book-intro-height', intro.offsetHeight + 'px');
      var rect = root.getBoundingClientRect();
      var size = stage.getBoundingClientRect();
      var mobile = !desktop.matches;
      // On phones a compact sticky introduction sits above the scene. Use the
      // stable scene height so Safari's collapsing toolbar cannot scrub time.
      var introHeight = mobile && intro ? intro.offsetHeight : 0;
      if (mobile && intro) {
        // Follow the scene once its sticky hold ends; stop translating once
        // the heading has cleared the viewport so the parent can carry it away.
        var stageTop = parseFloat(window.getComputedStyle(stage).top) || 0;
        var introExit = Math.max(-stageTop, Math.min(0, size.top - stageTop));
        intro.style.transform = 'translate3d(0,' + introExit + 'px,0)';
      }
      var timelineHeight = mobile ? size.height : window.innerHeight;
      var p = clamp((-rect.top - introHeight) / Math.max(1, root.offsetHeight - timelineHeight - introHeight));
      p = heldProgress(p, mobile);
      var scrollProgress = p;
      // Pause the original choreography while the reader visits each page.
      // Resume directly at card release, retaining the enlarged right-page pose.
      if (mobile && p > .26) p = p < .56 ? .26 : mix(.48, 1, clamp((p - .56) / .44));
      // Reserve the final scroll beat for listening after all three cards land.
      if (p > .75) p = Math.min(1, .75 + (p - .75) * .25 / .15);
      var backgroundProgress = mobile ? scrollProgress : p;
      if(yellow && !mobile) {
        var yellowAngle = 16 * Math.PI / 180;
        var yellowOverhang = (yellow.offsetWidth * Math.sin(yellowAngle) + yellow.offsetHeight * (Math.cos(yellowAngle) - 1)) / 2;
        var yellowStart = Math.max(0, yellowOverhang - size.height * .03 + 24);
        var yellowExit = phase(backgroundProgress,.1,.72);
        var yellowEnd = mobile ? -(size.height * .03 + yellow.offsetHeight + yellowOverhang + 24) : -size.height * .9;
        yellow.style.transform='translateY('+mix(yellowStart,yellowEnd,yellowExit)+'px) rotate(16deg)';
      }
      if(lavender && !mobile) {
        // Include the rotated shape's lower edge so its final curve clears the pin.
        var angle = 8 * Math.PI / 180;
        var rotatedOverhang = (lavender.offsetWidth * Math.sin(angle) + lavender.offsetHeight * (Math.cos(angle) - 1)) / 2;
        var lavenderTravel = size.height * (mobile ? 1.78 : .78) + rotatedOverhang + 24;
        lavender.style.transform='translateY('+(-lavenderTravel*phase(backgroundProgress,.78,.98))+'px) rotate('+mix(-24,-8,phase(backgroundProgress,.78,.98))+'deg)';
      }
      var opening = phase(p, .04, .24);
      var slideLeft = phase(p, .29, .43);
      var lift = phase(p, .48, .65);
      var arrival = phase(p, .75, .88);

      // Unfold into the foreground, hold in the middle, then slide left before lifting.
      var bookX = mix(-.29, .22, opening) - .54 * slideLeft;
      var bookScale = 1.4;
      var tileWidth = mobile ? .28 : .24;
      var deviceWidth = .88 * size.width;
      var deviceLeft = .06 * size.width;
      var deviceTop = .26 * size.height;
      if (mobile) {
        var heightFit = size.height * .82 / (size.width * .92 * 957 / 1246);
        var closedScale = Math.min(1.85, heightFit);
        var readingScale = Math.min(1.95, heightFit);
        // Follow the opening leaf directly into the enlarged left-page pose.
        // The book never pulls back to a full-spread overview on mobile.
        bookScale = mix(closedScale, readingScale, opening);
        var pageCenter = mix(.25, .75, phase(scrollProgress, .40, .49));
        bookX = mix(-.2093 * closedScale, (.5 - pageCenter) * .92 * bookScale, opening);
        deviceWidth = Math.min(deviceWidth, Math.min(size.height * .82, Math.max(150, size.height - 124)) * 769 / 592);
        deviceLeft = (size.width - deviceWidth) / 2;
        deviceTop = Math.max(0, (size.height - 80 - deviceWidth * 592 / 769) / 2);
        device.style.width = deviceWidth + 'px';
        device.style.left = deviceLeft + 'px';
        device.style.top = deviceTop + 'px';
        stage.style.setProperty('--book-controls-top', (deviceTop + deviceWidth * 592 / 769 + 20) + 'px');
      }
      var bookHeight = size.width * .92 * 957 / 1246;
      var bookLift = .78 * size.height;
      if (mobile) {
        // Clear the whole scaled book, including its shadow, above the scene.
        // A fixed viewport fraction leaves a purple edge below the sticky intro.
        var bookBottom = size.height / 2 - .3585 * size.width + bookHeight * (1 + bookScale) / 2;
        bookLift = Math.max(bookLift, bookBottom + 24);
      }
      book.style.transform = 'translate3d(' + (bookX * size.width) + 'px, ' + (-bookLift * lift) + 'px, 0) scale(' + bookScale + ')';
      book.style.opacity = String(1 - phase(p, .73, .80));
      root.dataset.bookV3Phase = p < .04 ? 'closed' : p < .29 ? 'opening' : p < .48 ? 'left' : p < .75 ? 'tiles' : p < .99 ? 'docking' : 'listening';
      if (mobile && scrollProgress >= .24 && scrollProgress < .56) root.dataset.bookV3Phase = scrollProgress < .40 ? 'read-left' : scrollProgress < .49 ? 'read-pan' : 'read-right';
      // A fixed right page plus one two-sided cover; the map lives on its reverse.
      if (spread) {
        spread.style.opacity = '1';
        // The tilted spread export extends beyond the closed, upright cover.
        // Keep it within the cover outline until the leaf starts opening.
        var revealPage = phase(opening, 0, .25);
        spread.style.clipPath = 'polygon(49.95% ' + (5 * (1-revealPage)) + '%, ' + (100 - 4.5 * (1-revealPage)) + '% ' + (5 * (1-revealPage)) + '%, ' + (100 - 4.5 * (1-revealPage)) + '% ' + (100 - 9 * (1-revealPage)) + '%, 56% ' + (100 - 9 * (1-revealPage)) + '%)';
      }
      cover.style.transform = 'rotateZ(-4.5deg) rotateY(' + (-180 * opening) + 'deg) rotateZ(4.5deg)';
      // WebKit can paint a nested image through its parent's backface. Switch
      // visibility at the edge-on position while keeping the real 3D turn.
      if (coverFront) coverFront.style.visibility = mobile && opening > .5 ? 'hidden' : '';
      if (coverBack) coverBack.style.visibility = mobile && opening < .5 ? 'hidden' : '';
      device.style.transform = 'translate3d(0,' + (size.height * .8 * (1 - arrival)) + 'px,0) rotate(' + (9 * (1 - arrival)) + 'deg)';
      device.style.opacity = String(phase(p, .75, .80));
      tiles.forEach(function (tile, i) {
        var emerge = phase(p, .48 + i * .025, .62 + i * .025);
        var detached = p > .48 + i * .025;
        if (emptySlots[i]) emptySlots[i].style.opacity = detached ? '1' : '0';
        var dockEnd = .91 + (2-i)*.035;
        var tileDock = phase(p, .83 + (2-i)*.035, dockEnd);
        if (leds[i]) leds[i].style.opacity = p >= dockEnd ? '1' : '0';
        // Centers and widths measured in the 1246 × 957 printed spread.
        // Use the same book transform so the hand-off has no position/size jump.
        var sourceX = [776, 793, 811][i] / 1246;
        var sourceY = [215, 437, 659][i] / 957;
        var x = mix(.5 + bookX + (sourceX - .5) * .92 * bookScale, mobile ? .2 : .24, emerge);
        var sourceCenterY = .5 + (-.3585 * size.width + bookHeight / 2 + (sourceY - .5) * bookHeight * bookScale - bookLift * lift) / Math.max(1, size.height);
        var y = mix(sourceCenterY, mobile ? .26 + i * .24 : .24 + i * .25, emerge);
        // Slot centers from the original 769 × 592 Figma device export.
        x = mix(x, (deviceLeft + deviceWidth * (193 + i * 192) / 769) / size.width, tileDock);
        y = mix(y, (deviceTop + deviceWidth * 163 / 769) / Math.max(1, size.height), tileDock);
        var sourceScale = 170 / 1246 * .92 * bookScale / tileWidth;
        var floatingScale = mobile ? Math.min(1, size.height * .18 / (tileWidth * size.width)) : Math.min(.7, size.height * .18 / (tileWidth * size.width));
        var dockScale = mobile ? deviceWidth / size.width * .24 * .79 / (.88 * tileWidth) : .79;
        var scale = mix(mix(sourceScale, floatingScale, emerge), dockScale, tileDock);
        var rotation = mix(mix(-4.5, [-7, 5, -4][i], emerge), 0, tileDock);
        tile.style.transform = 'translate3d(' + (x * size.width) + 'px,' + (y * size.height) + 'px,0) translate(-50%,-50%) rotate(' + rotation + 'deg) scale(' + scale + ')';
        tile.style.opacity = detached ? '1' : '0';
        var label = labels[i];
        if (label) {
          var reveal = phase(p, .58 + i * .025, .64 + i * .025);
          var fade = phase(p, .75, .83);
          label.style.opacity = String(reveal * (1 - fade));
          label.style.transform = 'translate3d(0,' + (28 * (1 - reveal) - 20 * fade) + 'px,0)';
        }
      });
      // Audio can pause offscreen; the player UI follows the listening phase
      // independently and remains in the scene until the animation rewinds.
      setReady(p >= .99 && rect.top + root.offsetHeight > 0);
    }
    function schedule() { if (root.dataset.bookV3Mode === 'scroll' && !frame) frame = window.requestAnimationFrame(render); }
    function desiredMode() { return !reduced.matches && (desktop.matches || window.innerHeight >= 500) ? 'scroll' : 'static'; }
    function sizeTimeline() {
      viewportWidth = window.innerWidth;
      root.style.removeProperty('--book-scroll-height');
      if (!desktop.matches && root.dataset.bookV3Mode === 'scroll') {
        // A toolbar resize must not change fourteen viewports of page height
        // above the visitor. Refresh the mobile length only on a width change.
        root.style.setProperty('--book-scroll-height', root.offsetHeight + 'px');
      }
    }
    function resize() {
      cancelSnap();
      if (root.dataset.bookV3Mode !== desiredMode()) mode();
      else {
        if (window.innerWidth !== viewportWidth) sizeTimeline();
        schedule();
      }
    }
    function mode() {
      cancelSnap();
      if (frame) window.cancelAnimationFrame(frame);
      frame = 0;
      // In short landscape, a pinned heading would leave no useful reading area.
      root.dataset.bookV3Mode = desiredMode();
      clear();
      sizeTimeline();
      if (root.dataset.bookV3Mode === 'scroll') render();
    }
    window.addEventListener('scroll', scroll, { passive: true });
    window.addEventListener('wheel', input, { passive: true });
    window.addEventListener('keydown', input);
    window.addEventListener('pointerdown', cancelSnap, { passive: true });
    window.addEventListener('touchstart', input, { passive: true });
    window.addEventListener('touchend', touchEnd, { passive: true });
    window.addEventListener('touchcancel', touchEnd, { passive: true });
    window.addEventListener('resize', resize, { passive: true });
    desktop.addEventListener('change', mode);
    reduced.addEventListener('change', mode);
    // SVG <image> has no native lazy loading: fetch the book artwork once the section approaches.
    function loadArtwork() {
      root.querySelectorAll('image[data-book-image]').forEach(function (image) {
        image.setAttribute('href', image.getAttribute('data-book-image'));
        image.removeAttribute('data-book-image');
      });
    }
    var artwork = 'IntersectionObserver' in window && !(window.Shopify && window.Shopify.designMode) ? new window.IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      artwork.disconnect(); artwork = null; loadArtwork();
    }, { rootMargin: '1000px 0px' }) : null;
    if (artwork) artwork.observe(root); else loadArtwork();
    instances.set(root, function () {
      if (artwork) artwork.disconnect();
      cancelSnap();
      window.cancelAnimationFrame(frame);
      window.removeEventListener('scroll', scroll);
      window.removeEventListener('wheel', input);
      window.removeEventListener('keydown', input);
      window.removeEventListener('pointerdown', cancelSnap);
      window.removeEventListener('touchstart', input);
      window.removeEventListener('touchend', touchEnd);
      window.removeEventListener('touchcancel', touchEnd);
      window.removeEventListener('resize', resize);
      desktop.removeEventListener('change', mode);
      reduced.removeEventListener('change', mode);
      clear(); delete root.dataset.bookV3Mode; delete root.dataset.bookV3Phase; delete root.dataset.bookV3Ready; instances.delete(root);
    });
    mode();
  }
  function scan(scope) {
    if (scope.matches && scope.matches('[data-book-v3]')) init(scope);
    scope.querySelectorAll('[data-book-v3]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (cleanup, root) { if (root === event.target || event.target.contains(root)) cleanup(); });
  });
})();
